import { render, staticRenderFns } from "./Karin-table.vue?vue&type=template&id=19145761&scoped=true"
import script from "./Karin-table.vue?vue&type=script&lang=js"
export * from "./Karin-table.vue?vue&type=script&lang=js"
import style0 from "./Karin-table.vue?vue&type=style&index=0&id=19145761&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19145761",
  null
  
)

export default component.exports